<div class="form-input" [ngClass]="{ long: isLong, light: (1 | colourTheme) === false }">
    <mat-form-field>
        <mat-label>{{ title }}</mat-label>
        <input
            matInput
            type="text"
            [(ngModel)]="value"
            [formControl]="formControl"
            [name]="nameField()"
            autocomplete="off"
        />
    </mat-form-field>
</div>
